import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput, FormTextarea } from '@/_components';

import { IndustriesSelect } from './components';
import type { IndustryFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<IndustryFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  const [id] = form.watch(['id']);

  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Industry (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="parent"
        render={({ field }) => (
          <IndustriesSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            value={field.value}
            label="Parent"
            onValueChange={field.onChange}
            disabled={!isEditable}
            filterId={id}
          />
        )}
      />

      <FormField
        control={form.control}
        name="consumer_label"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Consumer Label"
            {...field}
            disabled={!isEditable}
          />
        )}
      />

      <div className="col-span-12">
        <FormField
          control={form.control}
          name="description"
          render={({ field }) => <FormTextarea label="Description" {...field} disabled={!isEditable} />}
        />
      </div>
    </>
  );
}
